const displayName = 'Rekrytering'
const appName     = 'recruitment'

export { displayName, appName }
